module.exports = __webpack_public_path__ + "img/trash-slate-icon.d29a0723.svg";